var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-4 min-h-0"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }